import { Navigate, Outlet } from "react-router-dom";

import { useAuth } from "@/hooks/use-auth";

import { Loader2 } from "lucide-react";

import { useEffect, useState } from "react";

import { Button } from "@/components/ui/button";



interface ProtectedRouteProps {

  requireSubscription?: boolean;

  requireAdmin?: boolean;

  children?: React.ReactNode;

}



export function ProtectedRoute({

  requireSubscription = false,

  requireAdmin = false,

  children

}: ProtectedRouteProps) {

  const {

    user,

    profile, // ✅ NOVO

    loading,

    hasActiveSubscription,

    isAdmin,

    isEmailVerified, // ✅ NOVO

    subscriptionLoaded, // ✅ NOVO: Estado de subscription carregada

    refreshProfile,

    signOut

  } = useAuth();



  useEffect(() => {

    console.log(`[ProtectedRoute ${window.location.pathname}] state:`, {

      user: user?.id,

      loading,

      isAdmin,

      hasActiveSubscription,

      subscriptionLoaded,

      profile_verified: profile?.is_verified

    });

  }, [user, loading, isAdmin, hasActiveSubscription, subscriptionLoaded, profile]);



  // ✅ Adicionar timeout de segurança

  const [loadingTimeout, setLoadingTimeout] = useState(false);



  useEffect(() => {

    const timer = setTimeout(() => {

      if (loading) {

        console.error('⚠️ Loading timeout (60s) - forçando redirect para /auth');

        setLoadingTimeout(true);

      }

    }, 60000); // 60 segundos máximo



    return () => clearTimeout(timer);

  }, [loading]);



  // Se timeout de loading, mostrar erro com opção de retry

  if (loadingTimeout) {

    return (

      <div className="min-h-screen flex flex-col items-center justify-center bg-background p-4 text-center">

        <div className="max-w-md space-y-4">

          <div className="flex justify-center">

            <div className="p-3 rounded-full bg-destructive/10">

              <Loader2 className="w-8 h-8 text-destructive" />

            </div>

          </div>

          <h2 className="text-xl font-semibold">O carregamento está demorando mais que o esperado</h2>

          <p className="text-muted-foreground">

            Houve uma demora na comunicação com o servidor. Você deseja tentar carregar os dados novamente?

          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center pt-2">

            <Button

              onClick={() => {

                setLoadingTimeout(false);

                refreshProfile();

              }}

              variant="default"

              className="gap-2"

            >

              <Loader2 className="w-4 h-4" />

              Tentar Novamente

            </Button>

            <Button

              onClick={() => signOut()}

              variant="outline"

            >

              Sair

            </Button>

          </div>

        </div>

      </div>

    );

  }



  // Loading inicial

  if (loading) {

    return (

      <div className="min-h-screen flex items-center justify-center bg-background">

        <Loader2 className="w-8 h-8 animate-spin text-primary" />

      </div>

    );

  }



  // Verificar autenticação

  if (!user) {

    return <Navigate to="/auth" replace />;

  }



  // Verificar admin

  if (requireAdmin && !isAdmin) {

    return <Navigate to="/dashboard" replace />;

  }



  // ✅ CRÍTICO: Verificar email confirmado via flag descentralizada do AuthContext

  // Ignora verificação se for admin

  if (user && !isAdmin && !isEmailVerified) {

    console.log('⚠️ Perfil não verificado - redirecionando para /email-verification');

    return <Navigate to="/email-verification" replace />;

  }



  // ✅ CRÍTICO: Só verificar subscription SE já tiver carregado

  if (requireSubscription && subscriptionLoaded && !hasActiveSubscription && !isAdmin) {

    console.log('🔴 Redirecionando para /select-plan - sem subscription ativa');

    return <Navigate to="/select-plan" replace />;

  }



  // ✅ Se requireSubscription MAS ainda não carregou, mostrar loading

  if (requireSubscription && !subscriptionLoaded) {

    console.log('⏳ Aguardando carregamento de subscription...');

    return (

      <div className="min-h-screen flex items-center justify-center bg-background">

        <Loader2 className="w-8 h-8 animate-spin text-primary" />

      </div>

    );

  }



  return children ? <>{children}</> : <Outlet />;

}

